import { createFileRoute } from "@tanstack/react-router";
import QueryLogsPage from "@/features/query-logs/QueryLogsPage";

export const Route = createFileRoute("/_admin/query-logs")({
  component: QueryLogsPage,
});
